var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16ZM11.248 11.7707V11.7713C10.71 11.7713 9.01067 9.886 4.23467 10.8647C4.10867 10.8973 3.944 10.9487 3.85067 10.9487C3.24067 10.9487 3.124 10.036 3.78 9.89667C6.422 9.31333 9.122 9.36467 11.4247 10.742C11.974 11.0927 11.7407 11.7707 11.248 11.7707ZM12.1167 9.65533C12.0413 9.63533 12.0633 9.70133 11.7187 9.52C9.702 8.32667 6.69667 7.84533 4.022 8.57133C3.86733 8.61333 3.78333 8.65533 3.638 8.65533C2.924 8.65533 2.73467 7.58133 3.51267 7.362C6.65667 6.47867 10.0293 6.994 12.3773 8.39067C12.6387 8.54533 12.742 8.746 12.742 9.026C12.7387 9.374 12.468 9.65533 12.1167 9.65533ZM3.032 4.66533C6.04733 3.78267 10.6107 4.06133 13.448 5.71733C14.1753 6.13667 13.8893 7.19733 13.116 7.19733L13.1153 7.19667C12.9473 7.19667 12.844 7.15467 12.6987 7.07067C10.4033 5.7 6.296 5.37133 3.63867 6.11333C3.522 6.14533 3.37667 6.19667 3.222 6.19667C2.796 6.19667 2.47067 5.864 2.47067 5.43533C2.47067 4.99733 2.742 4.74933 3.032 4.66533Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.9f9035a5.svg";
export { ForwardRef as ReactComponent };